<script setup>

import { ref } from "vue";
import { useStore } from 'vuex';

const store = useStore();
const confirmationVisible = ref(false);

const destroyCart = () => {
  store.dispatch('cart/destroy');
  confirmationVisible.value = false;
}

</script>

<template>
  <div name="clearCartComponent" v-if="store.state.cart.items.length">

    <button id class="text-danger text-small btn btn-transparent" style="margin-top: -7px" :disabled="confirmationVisible" :class="{ 'disabled' : confirmationVisible}" @click="confirmationVisible = true">
      <i class="right lnr icon-trash"></i>
      {{ __("clear_cart") }}
    </button>

    <Transition name="fade-y">

      <div id="clearCartConfirmation" v-if="confirmationVisible">

        <div class="d-flex w-100 flex-column mb-3">
          <span class="text-large">{{ __("are_you_sure") }}</span> <span>{{ __("this_action_cannot_be_undone") }}</span>
        </div>

        <div class="w-100 d-flex gap-3 justify-content-center">

          <button class="btn btn-primary" @click="destroyCart">
            <i class="right lnr icon-trash"></i> {{ __("yes_empty_the_cart") }}
          </button>

          <button class="btn btn-grey" @click="confirmationVisible = false">
            <i class="right lnr icon-cross"></i> {{ __("cancel") }}
          </button>

        </div>

      </div>

    </Transition>

  </div>
</template>